let cachedEnabled = null;
let inflight = null;

export function resetLimitOvertimeReportCache() {
  cachedEnabled = null;
  inflight = null;
}

/**
 * 是否启用限制超时报工（type 78 + limitHour）；结果按会话缓存。
 */
export function fetchLimitOvertimeReportEnabled(http) {
  if (cachedEnabled !== null) {
    return Promise.resolve(cachedEnabled);
  }
  if (inflight) {
    return inflight;
  }
  inflight = http
    .get('/web/production/config/limitOvertimeReportEnabled')
    .then(res => {
      const payload = res && res.data;
      const v = payload && payload.limitOvertimeReportEnabled;
      cachedEnabled = !!v;
      inflight = null;
      return cachedEnabled;
    })
    .catch(() => {
      inflight = null;
      cachedEnabled = false;
      return false;
    });
  return inflight;
}

export function manualDatetimeToMs(str) {
  if (str == null || str === '') {
    return null;
  }
  if (typeof str === 'number' && !isNaN(str)) {
    return str;
  }
  const t = Date.parse(String(str).replace(/-/g, '/'));
  return isNaN(t) ? null : t;
}
